<template>
  <client-only>
    <div>
      <the-header :relative="true"></the-header>
      <div class="help-content">
      <div class="init-indicator">
        <div class="init-title">How can we help you?</div>
        <div class="init-desc">Browse help topics below.</div>
      </div>
      <ul class="help-list">
        <li v-for="(question, index) in helpCenterQuestions" :key="index"
            @click="router.push(`/help/${index}`)"
            class="help-item">
          <span class="help-title">{{ question.title }}</span>
          <img src="/icons/arrow_down_black.png" alt="Expand" class="arrow-icon" />
        </li>
      </ul>
    </div>
      <the-footer></the-footer>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import helpCenterQuestions from "@/helper/helpCenterQuestions";
import {useRouter} from "vue-router";
const router = useRouter();

definePageMeta({
  layout: 'default'
});

</script>

<style scoped>
.help-content {
  padding: 40px 40px;
  color: black;
  text-align: center;
}
.init-indicator {
  width: 100%;
  max-width: 1280px;
  padding: 58px 0;
  border: 0.5px solid #b8b8b8;
  border-radius: 10px;
}
.init-title {
  font-size: 32px;
  font-weight: 500;
  line-height: 1;
}
.init-desc {
  line-height: 1;
  font-size: 16px;
  padding-top: 23px;
  font-weight: 300;
}
.help-list {
  margin-top: 40px;
  list-style: none;
  padding: 0;
  border: 0.5px solid #b8b8b8;
  border-radius: 10px;
  overflow: hidden;
  max-width: 830px;
  margin-left: auto;
  margin-right: auto;
}
.help-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px;
  border-bottom: 0.5px solid #b8b8b8;
  font-size: 16px;
  font-weight: 500;
  color: black;
  cursor: pointer;
}
.help-item:last-child {
  border-bottom: none;
}
.help-title {
  text-align: left;
}
.arrow-icon {
  width: 16px;
  height: 16px;
}
.help-item:hover {
  background-color: #f5f5f5;
}
</style>
